import React from 'react';
import { motion } from 'framer-motion';
const products = [{
  id: 'viandas',
  title: 'Viandas Rentables',
  emoji: '🍲',
  price: '$9.900',
  description: 'Aprendé a crear y vender viandas rentables desde tu casa con un sistema paso a paso. Incluye recetas, estrategias de pre-venta, guía de precios, KitPro + 6 bonos exclusivos y módulo premium para escalar con PedidosYa y Rappi.',
  image: 'https://cdn.magicpatterns.com/uploads/cx49UkW6LanwoBFnQpDJWL/Captura_de_pantalla_2026-04-30_a_las_9.02.10_p._m..png',
  buttonText: 'VER PROGRAMA',
  link: 'https://viandasrentables.cocinaydulcesrentables.com'
}, {
  id: 'palomitas',
  title: 'Palomitas Gourmet',
  emoji: '🍿',
  price: '$9.900',
  description: 'Aprendé a crear y vender Palomitas Gourmet desde tu casa. Incluye técnica de caramelización, +30 recetas estrella, guía de presentación premium para eventos y 7 bonos exclusivos. Todo listo para empezar hoy.',
  image: 'https://cdn.magicpatterns.com/uploads/xxuZDmH6paWt4oBkbvU5Gv/Captura_de_pantalla_2026-05-01_a_las_1.28.40_a._m..png',
  buttonText: 'VER CURSO',
  link: 'https://palomitasgourmet.cocinaydulcesrentables.com'
}, {
  id: 'recetas-magicas',
  title: 'Recetas Mágicas para Niños que Odian las Verduras',
  emoji: '🥦✨',
  price: '$6.900',
  description: 'Más de 250 recetas creativas para que tus hijos coman verduras sin notarlo. Milanesas, pancakes, huevos y postres llenos de sabor. ¡Comidas divertidas, nutritivas y fáciles para toda la familia! + 5 Bonos Exclusivos.',
  image: 'https://cdn.magicpatterns.com/uploads/bsUHV7bHDmDs9RpqAY7xZZ/ChatGPT_Image_24_feb_2026_23_42_26.png',
  buttonText: 'VER RECETARIO',
  link: 'https://recetasverduraskids.cocinaydulcesrentables.com'
}];
export function ProductCards() {
  return <section id="productos" className="py-24 bg-[#FAFAF8]" data-id="element-65">
      <div className="container mx-auto px-6 md:px-12" data-id="element-66">
        <div className="text-center mb-16" data-id="element-67">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-stone-800 mb-4" data-id="element-68">
            Nuestros Programas
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '60px'
        }} viewport={{
          once: true
        }} className="h-1 bg-[#C9A96E] mx-auto rounded-full" data-id="element-69" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-70">
          {products.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} whileHover={{
          y: -10
        }} className="bg-white rounded-2xl overflow-hidden shadow-xl shadow-stone-200/50 flex flex-col group" data-id="element-71">
              <div className="relative h-64 overflow-hidden" data-id="element-72">
                <div className="absolute inset-0 bg-stone-900/10 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-73" />
                <img src={product.image} alt={product.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-74" />
              </div>

              <div className="p-8 flex flex-col flex-grow" data-id="element-75">
                <div className="flex items-center gap-3 mb-4" data-id="element-76">
                  <span className="text-2xl" data-id="element-77">{product.emoji}</span>
                  <h3 className="text-2xl font-serif font-bold text-stone-800" data-id="element-78">
                    {product.title}
                  </h3>
                </div>

                {product.price && <div className="mb-4" data-id="element-79">
                    <span className="text-3xl font-serif font-bold text-[#5B9A6F]" data-id="element-80">
                      {product.price}
                    </span>
                    <span className="text-stone-500 text-sm ml-2" data-id="element-81">ARS</span>
                  </div>}

                <p className="text-stone-600 mb-8 flex-grow leading-relaxed" data-id="element-82">
                  {product.description}
                </p>

                <a href={product.link} className="block w-full text-center bg-[#5B9A6F] hover:bg-[#4A8A5E] text-white py-4 rounded-xl font-semibold transition-all duration-300 shadow-md shadow-[#5B9A6F]/20 hover:shadow-lg hover:shadow-[#5B9A6F]/30" data-id="element-83">
                  {product.buttonText}
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}